import React, { forwardRef, useCallback, useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { useDebounce } from "../../hooks";
import { CloseIcon, SearchIcon } from "../../icons";
import TextField from "../TextField/TextField";
import styles from "./searchBar.module.scss";
const SearchBarIcon = ({ value, onClick, }) => {
    if (value)
        return (React.createElement(InputAdornment, { position: "end" },
            React.createElement(IconButton, { onClick: onClick, className: styles["icon-button"], "aria-label": "Clear search" },
                React.createElement(CloseIcon, null))));
    else
        return (React.createElement(InputAdornment, { position: "end", className: styles["search-icon"] },
            React.createElement(SearchIcon, null)));
};
const SearchBar = forwardRef(({ onChange, value, debounceTimer, isFullWidth = true, ...props }, inputRef) => {
    var _a;
    const [localValue, setLocalValue] = useState(value);
    useEffect(() => {
        setLocalValue(value);
    }, [value]);
    const handleOnChange = useCallback((newValue) => {
        if (value === newValue)
            return;
        onChange(newValue);
    }, [onChange, value]);
    useDebounce(localValue, debounceTimer, handleOnChange);
    return (React.createElement(TextField, { fullWidth: isFullWidth, ...props, value: localValue, onChange: (event) => setLocalValue(event.target.value), className: `${styles.root} ${props.className}`, inputRef: inputRef, slotProps: {
            ...props.slotProps,
            input: {
                ...(_a = props.slotProps) === null || _a === void 0 ? void 0 : _a.input,
                endAdornment: (React.createElement(SearchBarIcon, { value: localValue, onClick: () => setLocalValue("") })),
            },
        } }));
});
SearchBar.displayName = "SearchBar";
export default SearchBar;
//# sourceMappingURL=SearchBar.js.map